import { NgModule } from '@angular/core';
import { FooterThemesComponent } from './footer-themes.component';
import { FooterComponent } from './features/components/footer/footer.component';
import { FooterTwoComponent } from './features/components/footer-two/footer-two.component';
import { FooterThreeComponent } from './features/components/footer-three/footer-three.component';
import { FooterFourComponent } from './features/components/footer-four/footer-four.component';
import { FooterTheme1Component } from './features/footer-theme1/footer-theme1.component';
import { StoreModule } from '@ngrx/store';
import { footerThemeReducer } from './domain/facates/store/FooterThemes.reducers';
import { EffectsModule } from '@ngrx/effects';
import { FooterEffect } from './domain/facates/store/FooterThemes.effects';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SharedModule } from 'imakeapp-shared';
import { MobileFooterTheme1Component } from './features/mobile-footer-theme/footer-theme1.component';
import { HeadersFacade } from 'imakeapp-header-themes';
import { FooterTheme2Component } from './features/footer-theme2/footer-theme2.component';






@NgModule({
  declarations: [
    FooterThemesComponent,
    FooterComponent,
    FooterTwoComponent,
    FooterThreeComponent,
    FooterFourComponent,
    FooterTheme1Component,
    MobileFooterTheme1Component,
    FooterTheme2Component
  ],
  imports: [
    SharedModule,
    StoreModule.forFeature("footer_theme" , footerThemeReducer),
    EffectsModule.forFeature([ FooterEffect ])
  ],
  exports: [
    FooterThemesComponent,
    FooterComponent,
    FooterTwoComponent,
    FooterThreeComponent,
    FooterFourComponent,
    FooterTheme1Component,
    FooterTheme2Component,
    MobileFooterTheme1Component

  ],providers:[HeadersFacade]
})
export class FooterThemesModule { }
